import React, { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Route, useHistory, useRouteMatch } from 'react-router'
import { csx, useToast } from '@vtex/admin-ui'
import { newOrder as newOrderAction } from '@/checkout-instore-legacy/utils/SidebarUtils'

import { DrawerTitle } from '../../../../../../ui/components'
import { CartRoute } from '../../constants'
import { TOAST_DEFAULT_DURATION_MS } from '../../../../../../core/constants'
import { ShareCartInfoContent } from './ShareCartInfoContent'
import { ShareCartGeneratedContent } from './ShareCartGeneratedContent'
import { copyToClipboard } from '../../../../../../core/utils/navigator'
import { useShareLink } from '../../hooks'
import { useFeatureFlag, useInitialPath } from '../../../../../../core/hooks'
import { useOrderForm } from '../../../../../../core/requests/checkout'
import { getNewSaleRoute } from '../../../../../../utils/getNewSaleRoute'

export const ShareCartContent = () => {
  const history = useHistory()
  const { path } = useRouteMatch()
  const showToast = useToast()
  const { formatMessage } = useIntl()
  const [additionalInfo, setAdditionalInfo] = useState('')
  const { getShareLink } = useShareLink()
  const shareLink = getShareLink()
  const initialPath = useInitialPath()
  const { orderForm } = useOrderForm()
  const { isNewSaleCartRedirectEnabled } = useFeatureFlag()

  const newSaleRoute = getNewSaleRoute(
    initialPath,
    isNewSaleCartRedirectEnabled()
  )

  const handleGenerateLinkClick = (_additionalInfo: string) => {
    setAdditionalInfo(_additionalInfo)

    history.push(`${CartRoute.Share}/${CartRoute.ShareGenerated}`)
  }

  const handleCopyShareLinkClick = async () => {
    await copyToClipboard(shareLink)

    showToast({
      variant: 'positive',
      dismissible: true,
      duration: TOAST_DEFAULT_DURATION_MS,
      message: formatMessage({
        id: 'checkout.options-drawer.share.copy-message',
      }),
    })
  }

  const handleSendByWhatsAppClick = () => {
    const shareLinkWithMessage = `${additionalInfo} ${shareLink}`.trim()
    const whatsAppLink = `https://api.whatsapp.com/send?text=${shareLinkWithMessage}`

    window.open(whatsAppLink)
  }

  const handleNewSaleButtonClick = () => {
    if (orderForm?.items.length) {
      showToast({
        message: formatMessage({
          id: 'checkout.toast.new-sale',
        }),
        action: {
          label: formatMessage({
            id: 'checkout.toast.new-sale.go-now',
          }),
          onClick: () => {
            history.push('/orders')
          },
        },
      })
    }

    newOrderAction()
    history.push(newSaleRoute)
  }

  return (
    <>
      <DrawerTitle className={csx({ marginBottom: '$space-4' })}>
        <FormattedMessage id="checkout.options-drawer.share.title" />
      </DrawerTitle>
      <Route path={path} exact>
        <ShareCartInfoContent onGenerateLinkClick={handleGenerateLinkClick} />
      </Route>
      <Route path={`${path}/${CartRoute.ShareGenerated}`}>
        <ShareCartGeneratedContent
          additionalInfo={additionalInfo}
          shareLink={shareLink}
          onCopyLinkClick={handleCopyShareLinkClick}
          onSendByWhatsappClick={handleSendByWhatsAppClick}
          onNewSaleClick={handleNewSaleButtonClick}
        />
      </Route>
    </>
  )
}
